import { Components, Theme } from '@mui/material/styles';

export const footerTheme: Components<Theme>['MuiAppBar'] = {
  // styleOverrides: {},
  // variants: [],
};
